/* eslint-disable */
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// core components
import downloadStyle from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.jsx";

import reactLogo from "assets/img/Logos/react.svg";
import reduxLogo from "assets/img/Logos/redux.svg";
import ethereumLogo from "assets/img/Logos/ethereum.svg";
import postgresqlLogo from "assets/img/Logos/postgresql.svg";
import firebaseLogo from "assets/img/Logos/firebase-1.svg";

import Divider from 'material-ui/Divider';

class SectionContent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h1>I realize new online ambitions with impact</h1>
              <h4>
                Founded in 2018 and based in The Netherlands or at the moment Southeast Asia,
                Pixsells New Internet was created after many years of developing
                necessary skills to inspire you with the latest 2018 Web Technologies.
              </h4>
              <br/>
              <h2><strong>React.js <small>and</small> Redux</strong></h2>
              <h3><strong>
                Yes, React is taking over front-end development. But why?
              </strong></h3>
              <h4>Working with the DOM API is tough. React gives me the
              ability to work with a virtual browser that is much easier to
              handle than the real browser.</h4>
              <h4>User Interfaces are everywhere. As I am mainly focussed on the 
              best UI's and UX's, React gives me the opportunity to declaratively describe 
              my User Interfaces and model the state of those interfaces. If the project 
              I am trying to interface can understand JavaScript, I can use React to 
              describe a User Interface for it</h4>
              <h4>React is just Javascript. When my Javascript skills increases,
              I just become a better React and Redux Developer.
              </h4>
            </GridItem>
            <GridItem xs={12} sm={12} md={8}>
              <h3><strong>
                Why I use Redux?
              </strong></h3>
              <h4>React failed at state transfer between the components. I noticed that
              data transfer between the component in React can become very difficult,
              especially with large and complicated apps</h4>
              <h4>Redux solves this state transfer problem. we store all the state in a 
              single place called <strong>store</strong>. Clear code, easy access of state, easy state 
              transfer are the major benefits of Redux.</h4>
            </GridItem>
            </GridContainer>
            <GridContainer className={classes.textCenter} justify="center">
            <GridItem xs={12} sm={6}>
                <h4>React.js Library</h4>
                  <img
                    src={reactLogo}
                    alt="React.js"
                    />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <h4>Redux</h4>
                  <img
                    src={reduxLogo}
                    alt="Redux"
                    />
              </GridItem>
          </GridContainer>
          <br />
          <Divider />
          <br />
          <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h2><strong>PostGreSQL <small>and</small> FireBase</strong></h2>
              <h3><strong>
              PostgreSQL "The world's most advanced open source database." Why?
              </strong></h3>
              <h4>I use PostGreSQL beacuse it's both relational and object-relational. 
              This gives it some advantages over other open source SQL databases 
              like MySQL, MariaDB and Firebird.</h4>
              <h4>Because PostgreSQL is an object-relational database, arrays of 
              values can be stored for most of the existing data types. MySQL, 
              MariaDB, and Firebird do not have this capability.</h4>
            </GridItem>
            <GridItem xs={12} sm={12} md={8}>
              <h3><strong>
                Why I use Firebase?
              </strong></h3>
              <h4>Firebase is a mobile-first offering. It was designed for mobile apps 
              (Android, iOS, and web where sensible), and favors projects with a focus 
              on mobile usage.</h4>
              <h4>Besides Firebase its Realtime Database it also handles Authentication,
              Storage and hosting facilities at a blazing speed.</h4>
            </GridItem>
            </GridContainer>
            <GridContainer className={classes.textCenter} justify="center">
            <GridItem xs={12} sm={6}>
                <h4>PostGreSQL</h4>
                  <img
                    src={postgresqlLogo}
                    alt="postgreSQL"
                    />
              </GridItem>
              <GridItem xs={12} sm={6}>
                <h4>FireBase</h4>
                  <img
                    src={firebaseLogo}
                    alt="Firebase"
                    />
              </GridItem>
          </GridContainer>
          <br />
          <Divider />
          <br />
          <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} md={8}>
              <h2><strong>Solidity | Ethereum Apps</strong></h2>
              <h3><strong>
              Solidity is designed to compile to code - for the Ethereum Virtual Machine.
              </strong></h3>
              <h4>Ethereum is an open software platform which allows development 
              of blockchain apps using the existing Ethereum blockchain. 
              Similar to Bitcoin, Ethereum is also a distributed public 
              blockchain network. 
              </h4>
              <h4>Solidity is a contract oriented high-level programing language 
              which is used for writing smart contacts.</h4>
              <h4>I use Solidity for implementing smart contracts on various 
              blockchain platforms. This platform has a lot of similarity with 
              JavaScript. Solidity does the process of verifying and enforcing 
              the constraints at compile-time as opposed to the run-time. 
              Solidity is basically there to develop and execute code in the 
              Ethereum Virtual Machine.</h4>
              <br/>
              <h4>I am using <strong>Ethereum Smart Contracts</strong> with Remix to solve major Startup problems.
              <strong> Remix</strong> is a great open source tool for writing Solidity contracts as well as testing, debugging and deployment
              of these contracts.
              With these Smart contracts it is <strong>much much safer</strong> to control money and 
              data flows within a commercial business model.</h4>
              <h4>For example Kickstarter.com. In the past there were many fraudulent creators
              who took the money and ran off.</h4>
              <h4>A <strong>Solidity Ethereum App</strong> controls in three steps safely and secure how the funds are distributed.</h4>
              <ul>
                <li>The contributors don't send money to the creator/founder directly, but to an
                Ethereum smart contract.</li>
                <br />
                <li>A spending request in the contract avoids the money being send to fraudulent external addresses.
                This spending request attempts to withdraw money from the contract and send to an approved external account. </li>
                <br />
                <li>Using Blockchain technology, all contributors need to vote for every spending request and an ideal
                business model has been created.</li>
              </ul>
            </GridItem>
            </GridContainer>
            <GridContainer className={classes.textCenter} justify="center">
            <GridItem xs={12} sm={6}>
                <br />
                <img
                  src={ethereumLogo}
                  alt="Ethereum"
                  />
            </GridItem>
          </GridContainer>
          <div className={classes.textCenter + " " + classes.sharingArea}>
            <GridContainer justify="center">
              <h5><strong>Have a look here for more ...</strong></h5>
            </GridContainer>
            <Button 
            color="twitter"
            href="https://reactjs.org"
            target="_blank">
              <i className={classes.socials + " fab fa-react"} /> React
            </Button>
            <Button 
            color="github"
            href="http://solidity.readthedocs.io/en/v0.4.21/index.html"
            target="_blank">
              <i className={classes.socials + " fab fa-ethereum"} /> Solidity
            </Button>
            <Button 
            color="facebook"
            href="https://remix.readthedocs.io/en/latest/"
            target="_blank">
              <i className={classes.socials + " fa fa-code"} /> Remix
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(downloadStyle)(SectionContent);



// WEBPACK FOOTER //
// ./src/views/ServicesPage/Sections/SectionContent.jsx